
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"21","viewBox":"0 0 12 21","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 10.5C12 10.0209 11.8034 9.57042 11.4405 9.22717L3.25142 1.48263C2.5104 0.781832 1.30057 0.781832 0.559546 1.48263C-0.181474 2.18343 -0.181474 3.32759 0.559546 4.02839L7.40265 10.5L0.559546 16.9717C0.196597 17.3078 0 17.7655 0 18.2446C0 18.7237 0.196597 19.1742 0.559546 19.5175C1.30057 20.2183 2.5104 20.2183 3.25142 19.5175L11.4405 11.7729C11.8034 11.4297 12 10.9792 12 10.5Z"}})])
          )
        }
      }
    